import _ from 'lodash'

export const INNER_ELEMENTS_MAP_TYPE_POSTFIX = 'InnerElementsMap'

/**
 * Determines if the given value is an InnerElementsMap wrapper,
 * based on the presence of a 'type' field and an 'innerElements' field.
 */
export const isInnerElementsMapWrapper = (val: any): boolean => {
    if (!_.isPlainObject(val)) {
        return false
    }

    const {type, innerElements} = val
    return _.isPlainObject(innerElements) && _.isString(type) && type.includes(INNER_ELEMENTS_MAP_TYPE_POSTFIX)
}
